export const darkTheme = {
    bg: "#000000",
    bgLight: "#000000",
    primary: "#FFFFFF",
    text_primary: "#FFFFFF",
    text_secondary: "#CCCCCC",
    text_skills: "#B3B3B3",
    card: "#000000",
    card_light: "#000000",
    button: "#FFFFFF",
    white: "#FFFFFF",
    black: "#000000",
    colored_detail: "#B3B3B3",
    highlighted_svg: "#FFFFFF",
    buttonGradient: "linear-gradient(180deg, #333333 0%, #666666 100%)"
};

export const lightTheme = {
    bg: "#FFFFFF",
    bgLight: "#FFFFFF",
    primary: "#000000",
    text_primary: "#000000",
    text_secondary: "#333333",
    text_skills: "#4D4D4D",
    card: "#FFFFFF",
    card_light: "#FFFFFF",
    button: "#000000",
    white: "#FFFFFF",
    black: "#000000",
    colored_detail: "#4D4D4D",
    highlighted_svg: "#000000",
    buttonGradient: "linear-gradient(180deg, #CCCCCC 0%, #e9e9e9 100%)"
};
